var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HttpClient } from "@angular/common/http";
import { ActiveProfileService, IpsBaseWebService } from "imagine-ui-ng-core";
import { environment } from "../../../../environments/environment";
var LocationByLocationGroupService = /** @class */ (function (_super) {
    __extends(LocationByLocationGroupService, _super);
    function LocationByLocationGroupService(http, activeProfileService) {
        var _this = _super.call(this, http, environment, activeProfileService) || this;
        _this.init("Location", "Profile", "v1");
        _this.route = _this.urlApiBaseProductPlusVersion + "LocationGroup/{id}/Location";
        return _this;
    }
    LocationByLocationGroupService.prototype.getByFixture = function (id, option) {
        this.LocationId = id;
        return this.getByRoute(this.route.replace("{id}", id));
    };
    LocationByLocationGroupService.prototype.headByLocationGroup = function (id, subGroupId) {
        return this.headByRoute(this.route.replace("{id}", id) + "?subGroupId=" + subGroupId);
    };
    // override ipsBaseWebService search method
    LocationByLocationGroupService.prototype.search = function (searchInfo, route) {
        return this.searchByRelation(searchInfo, "LocationGroup/" + searchInfo.id + "/Location" + "/Search");
    };
    return LocationByLocationGroupService;
}(IpsBaseWebService));
export { LocationByLocationGroupService };
